import { PermissionSet } from '../../../types';
import { PERMISSION_SET_SELECT_STYLE } from './assignmentStyles';

export interface PermissionSetAssignmentCellProps {
  value: string;
  permissionSets: PermissionSet[];
  ariaLabel: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export const PermissionSetAssignmentCell = ({
  value,
  permissionSets,
  ariaLabel,
  disabled,
  onChange
}: PermissionSetAssignmentCellProps) => (
  <select
    aria-label={ariaLabel}
    className={PERMISSION_SET_SELECT_STYLE}
    value={value}
    disabled={disabled}
    onChange={(event) => onChange(event.target.value)}>
    <option value="">Unassigned</option>
    {permissionSets.map((set) => (
      <option
        key={set.id}
        value={set.id}>
        {set.name}
      </option>
    ))}
  </select>
);
